import React from 'react';

import { box, CONTENT_WIDTH, MARGIN_X, pt } from '../slideGeometry';

/**
 * The line a section shows when it has no data, at the size the Paginator fitted it to.
 */
const EmptyStateBlock = ({ block }) => (
    <div
        className="tw-text-center tw-italic tw-text-charcoal-60"
        style={{ ...box(MARGIN_X, block.y + 20, CONTENT_WIDTH, 40), fontSize: pt(block.fit?.size ?? 11) }}
    >
        {block.message}
    </div>
);

export default EmptyStateBlock;
